import {useQuery} from '@tanstack/react-query';

import {trustAccountKeys} from '@/features/trust-accounts/hooks';
import {useApiClient} from '@/hooks';

import {trustAccountMembersApi} from '../api';

export function useTrustAccountMembersQuery(
  trustAccountId: string,
  {enabled = true}: {enabled?: boolean} = {}
) {
  const client = useApiClient();

  return useQuery({
    queryKey: trustAccountKeys.members(trustAccountId),
    queryFn: () => trustAccountMembersApi.fetchMembers(client, trustAccountId),
    select: response => response.data,
    enabled
  });
}

/** Trustee-only on the server — pass `enabled: false` for anyone else. */
export function useMemberCandidatesQuery(trustAccountId: string, {enabled}: {enabled: boolean}) {
  const client = useApiClient();

  return useQuery({
    queryKey: trustAccountKeys.memberCandidates(trustAccountId),
    queryFn: () => trustAccountMembersApi.fetchCandidates(client, trustAccountId),
    select: response => response.data,
    enabled
  });
}

export function useMemberEventsQuery(
  trustAccountId: string,
  {enabled = true}: {enabled?: boolean} = {}
) {
  const client = useApiClient();

  return useQuery({
    queryKey: trustAccountKeys.memberEvents(trustAccountId),
    queryFn: () => trustAccountMembersApi.fetchEvents(client, trustAccountId),
    select: response => response.data,
    enabled
  });
}
